<template>
  <div class="jigsaw_success">
     <van-overlay :show="successShow">
        <div class="jigsaw_success_wraper">
           <img src="../../assets/images/jigsaw/finished.png" class="jigsaw_success_wraper_pic1" v-show="gameType == '1'">
           <img src="../../assets/images/jigsaw/finished-game.png" class="jigsaw_success_wraper_pic2" v-show="gameType == '2'">
           <div class="jigsaw_success_wraper_prompt">
              <p>恭喜你已经通过所有关卡了，</p>
              <p>相信你以后能更加准确的识别喜怒哀乐了！</p>
              <p>如果还想继续巩固，可以重新开始哦！</p>
           </div>
        </div>
     </van-overlay>
  </div>
</template>

<script>
export default {
   name:"success-dialog",
   props:{
      successShow:{
         type:Boolean
      },
      gameType:{
         type:String, // 拼图:'1',连连看:'2'
         default() {
            return '1'
         },
      },
   },
   data() {
      return {

      }
   },
   watch:{

   },
   created(){},
   mounted() {},
   methods:{

   }
}
</script>

<style lang="scss" scoped>
.van-overlay{
    display: flex;
    justify-content: center;
    align-items: center;
    .jigsaw_success_wraper{
       .jigsaw_success_wraper_pic1{
          width:274px;
          height:198px;
       }
       .jigsaw_success_wraper_pic2{
          width:280px;
          height:201px;
       }
       .jigsaw_success_wraper_prompt{
          width:289x;
          height:60px;
          font-size:14px;
          color:#fff;
          line-height:20px;
          text-align: center;
          margin-top:17px;
       }
       
    }
}
</style>